import { IDefineCommand } from 'core-ts-types';
import { RouterHelper } from '../../global/helpers/router_helper';
import { INotificationDelegate } from '../../global/helpers/notification_delegate';

angular
  .module('capability-ng-academic-planner')
  .service(
    'preventAccessAndRedirectToAp3Command',
    (
      appConfigModel: any,
      defineCommandORM: IDefineCommand,
      routerHelper: RouterHelper,
      $location: ng.ILocationService
    ) => {
      return defineCommandORM('preventAccessAndRedirectToAp3Command', (deferred) => {
        // Allow access to Feedback History '/changelog' page
        const pathIsFeedbackHistory = $location.path().includes('/changelog');
        if (pathIsFeedbackHistory) {
          return deferred.resolve();
        }
        const ap3FeatureEnabled = appConfigModel.isFeatureEnabled('ap3-academic_planner_v3');

        // Redirect to AP3 if AP3 feature toggle is ON
        if (ap3FeatureEnabled) {
          return routerHelper.navigateFromRouter(deferred, 'my.ap3-restart');
        }
        return routerHelper.navigateFromRouter(deferred, 'my.feed');
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/routes/re_route_strategies/prevent_access_and_redirect_to_ap3_command.ts